module.exports = __webpack_public_path__ + "static/media/donbosco14.a5d80304.jpg";